<ul *ngIf="currentUser" nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed" class="submenu_container">
    <li nz-menu-item [nzMatchRouter]="true" [routerLink]="['dashboard']" routerLinkActive="router-link-active" (click)="clickMenu()">
        <div class="icon_cont" nz-icon>
            <mat-icon title="Dashboard" class="material-icons-outlined" [svgIcon]="'dashboard'"></mat-icon>
        </div>
        <span>Dashboard</span>
    </li>
    <li nz-submenu nzOpen>
        <div class="icon_cont" title>
            <mat-icon title="Applicazioni" nz-icon class="material-icons-outlined" [svgIcon]="'apps'"></mat-icon>
            <span>Applicazioni</span>
        </div>

        <ul>
            <li nz-menu-item [nzMatchRouter]="true" [routerLink]="['apps']" routerLinkActive="router-link-active" (click)="clickMenu()">
                <div class="icon_cont">
                    <mat-icon title="Tutte le App" class="material-icons-outlined" style="margin-left: -1px;" [svgIcon]="'apps'"></mat-icon>
                </div>
                <span>Tutte le app</span>
            </li>
            <div *ngFor="let app of currentUser.applications" [ngSwitch]="app.type">
                <li *ngSwitchCase="'applications'" nz-menu-item [nzMatchRouter]="true" [routerLink]="['/'+app.url]"
                    routerLinkActive="router-link-active" (click)="clickMenu()">
                    <div class="icon_cont">
                        <mat-icon [title]="app.label" class="material-icons-outlined" [svgIcon]="app.icon_class"></mat-icon>
                    </div>
                    <span>{{app.label}}</span>
                </li>
                <li *ngSwitchCase="'iframes'" nz-menu-item [nzMatchRouter]="true" [routerLink]="[app.url]"
                    routerLinkActive="router-link-active" (click)="clickMenu()">
                    <div class="icon_cont">
                        <mat-icon [title]="app.label" class="material-icons-outlined" [svgIcon]="app.icon_class+'_sidebar'"></mat-icon>
                    </div>
                    <span>{{app.label}}</span>
                </li>
                <li *ngSwitchCase="'external'" (click)="navigate(app)" nz-menu-item (click)="clickMenu()">
                    <div class="icon_cont">
                        <mat-icon [title]="app.label" class="material-icons-outlined" [svgIcon]="app.icon_class+'_sidebar'"></mat-icon>
                    </div>
                    <span>{{app.label}}</span>
                </li>
                <li *ngSwitchCase="'external-redirect'" (click)="navigate(app)" nz-menu-item (click)="clickMenu()">
                    <div class="icon_cont">
                        <mat-icon [title]="app.label" class="material-icons-outlined" [svgIcon]="app.icon_class+'_sidebar'"></mat-icon>
                    </div>
                    <span>{{app.label}}</span>
                </li>
            </div>
        </ul>
    </li>


    <li [checkPermission]="currentUser.privileges" [privilegesToCheck]="['applications_admin']" nz-menu-item
        [nzMatchRouter]="true" [routerLink]="['application-management']" routerLinkActive="router-link-active" (click)="clickMenu()"></li>

    <li [checkPermission]="currentUser.privileges" [privilegesToCheck]="['applications_admin']" nz-menu-item
        [nzMatchRouter]="true" [routerLink]="['application-management']" routerLinkActive="router-link-active" (click)="clickMenu()">
        <div class="icon_cont" nz-icon>
            <mat-icon title="Gestione App" class="material-icons-outlined" [svgIcon]="'settings'"></mat-icon>
        </div>
        <span>Gestione app</span>
    </li>
</ul>
